var mix = function mix(from, to, progress) {
  return -progress * from + progress * to + from;
};

export { mix };